import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Dashboard from './Dashboard';

import Companies from './Companies';
import EnterpriseDashboard from './EnterpriseDashboard';
import ValidateRequests from './ValidateRequests';
import CopyTransfer from './CopyTransfer';
import Operations from './Operations';
import Coupon from './Coupon/Coupon';
import Promotional from './Promotional/Promotional';

const MainPage = () => {
  const location = useLocation();

  const ROUTES = [
    { path: '/', component: Dashboard },
    { path: '/company', component: Companies },
    { path: '/enterprise-dashboard', component: EnterpriseDashboard },
    { path: '/copy-transfer', component: CopyTransfer },
    { path: '/operations', component: Operations },
    { path: '/validate-requests', component: ValidateRequests },
    { path: '/coupon', component: Coupon },
    { path: '/promotional', component: Promotional }
  ];

  if (!ROUTES.map(route => route.path).includes(location.pathname)) {
    window.location.href = '/';
  }

  return (
    <Routes>
      {ROUTES.map((route, key) => {
        return <Route key={key} path={route.path} element={<route.component />} />;
      })}
    </Routes>
  );
};

export default MainPage;
